import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { Product } from '../../../../../lib/models/api/product.model';
import { FormProductSelectionComponent } from '../../../../shared/components/form-inputs/form-product-selection/form-product-selection.component';
import { CaseProduct } from '../../../models/case-product.model';
import { Address } from './../../../../../lib/models/api/address.model';
import { MortgageApplication } from './../../../models/mortgage-application.model';

@Component({
  selector: 'boi-form-application-product-selection',
  templateUrl: '../../../../shared/components/form-inputs/form-product-selection/form-product-selection.component.html',
  styleUrls: ['../../../../shared/components/form-inputs/form-product-selection/form-product-selection.component.scss']
})
export class FormApplicationProductSelectionComponent
  extends FormProductSelectionComponent
  implements OnInit, OnChanges
{
  @Input() public mortgageApplication: MortgageApplication;

  public get selectionType(): string {
    return this.mortgageApplication.ProductSelectionTypeCode;
  }

  public set selectionType(value: string) {
    this.mortgageApplication.ProductSelectionTypeCode = value;
  }

  public get partAndPartRepaymentCaseProduct(): CaseProduct {
    return this.mortgageApplication.ApplicationProducts[1].CaseProduct;
  }

  public get isPartAndPartRepaymentType(): boolean {
    return this.mortgageApplication.ApplicationProducts.length > 1;
  }

  public ngOnInit(): void {
    this.initializeSelectionType();
    this.initialize();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.mortgageApplication &&
      changes.mortgageApplication.currentValue !== changes.mortgageApplication.previousValue
    ) {
      this.caseNumberAsHash = this.mortgageApplication.ApplicationCase.CaseNumberAsHash;
      this.caseProduct = this.mortgageApplication.ApplicationProducts[0].CaseProduct;
      this.isBuyToLet = this.mortgageApplication.isBuyToLet;
      this.isBrokerCase = this.mortgageApplication.isBrokerApplication;
      this.initializeSelectionType();
      this.initializeProductRelatedFields();
      this.setProductExpirationFlags();
    }
  }

  public resetSolicitorDetails(): void {
    this.mortgageApplication.SolicitorChosenCode = undefined;
    this.mortgageApplication.SolicitorSequenceNumber = undefined;
    this.mortgageApplication.SolicitorFromPanelCode = undefined;
    this.mortgageApplication.QuoteFromLegalPartnersCode = undefined;
    this.mortgageApplication.IndividualActing = undefined;
    this.mortgageApplication.SolicitorAddress = new Address();
  }

  protected getProductByProductCode(): Observable<Product> {
    return this.productService.getProductByProductCode(this.mortgageApplication, this.productCode);
  }

  protected getProductsByLoanType(): Observable<Array<Product>> {
    return this.productService.getProductsByLoanType(
      this.mortgageApplication,
      this.selectedLoanType,
      this.mortgageApplication.EPCRating
    );
  }

  protected getProductWarningMessage(): string {
    return this.getProductStatusWarning(
      this.product,
      this.referenceDataLabels.ProductWithdrawn,
      this.referenceDataLabels.ProductAboutToExpireApplication
    );
  }

  protected setFormApplicationLoanTypeCode(): void {
    this.mortgageApplication.LoanTypeCode = this.product.LoanTypeCode;
  }

  private initializeSelectionType(): void {
    this.selectionType =
      this.mortgageApplication.ProductSelectionTypeCode || this.referenceDataOptionLists.ProductSelectionByType;
  }
}
